import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../auth/authService';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import './css/UserForm.css';
import CountrySelector from './helpers/CountrySelector';
import profile from './images/profile_g.png';
import ludz from './images/ludz.png';
import lock from './images/lock.png';
import city from './images/city.png';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const UserForm = ({ isCollapsed, toggleSidebar }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        country: '',
        postal: '',
        phone: '',
        representing_company: false,
        company: '',
        nip_vat: '',
        position: '',
        company_adress: '',
        company_country: '',
        company_postal: ''
    });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [deletePassword, setDeletePassword] = useState('');
    const [deleteError, setDeleteError] = useState('');
    const [showPasswordChange, setShowPasswordChange] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [passwordSuccess, setPasswordSuccess] = useState('');



    const navigate = useNavigate();

    useEffect(() => {
        const user = authService.getCurrentUser();
        setCurrentUser(user);
    }, []);

    useEffect(() => {
        if (currentUser) {
            authService.getUserProfile(currentUser.access)
                .then(response => {
                    setFormData(prev => ({
                        ...prev,
                        ...response.data,
                        representing_company: !!(response.data.company || response.data.nip_vat)
                    }));
                })
                .catch(error => console.error(error));
        }
    }, [currentUser]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Special handler for the country dropdown
    const handleCountryChange = (option) => {
        setFormData(prevData => ({
        ...prevData,
        country: option ? option.value : ''
        }));
    };

    const handleSaveClick = (e) => {
        e.preventDefault();
        setShowModal(true);
    };

    const handleModalSubmit = () => {
        if (!currentUser) return;
    
        const profileData = {
            ...formData,
            is_filled: !!(formData.name && formData.surname && formData.country)
        };
    
        authService.updateUserProfile(currentUser.access, profileData)
            .then(() => {
                const updatedUser = { ...currentUser, is_filled: true };
                localStorage.setItem('user', JSON.stringify(updatedUser));
                window.location.reload();
            })
            .catch(error => console.error(error));
    };

    const handleModalCancel = () => {
        setShowModal(false);
    };
  
    const handleDeleteAccount = () => {
        if (!currentUser) return;
        
        authService.deleteUserProfile(currentUser.access, deletePassword)
            .then(() => {
                localStorage.removeItem('user');
                navigate('/login', { 
                    state: { 
                        message: 'Account has been terminated', 
                        messageType: 'success' 
                    } 
                });
            })
            .catch(err => {
                const message = err?.response?.data?.detail || 'Something went wrong';
                setDeleteError(message);
            });
    };

    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={1} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='home-content'>
                    
                    <h2 className='aval-endp mar-usr-prof'>Your profile</h2>
                    <p className='complete mar-usr-prof'>Complete your profile information to unlock all features of the app.</p>
                    
                    <form onSubmit={handleSaveClick} className="profile-form">
                        <div className="form-sections">
                            <div className="left-section">
                            <div className="user-prof">
                                <div className='us-prof-bg-div'>
                                    <div className='usr-prof-imgs'><img className="up-profile" src={ludz} alt="profile-icon" /></div>
                                    <div className='inpts-div'>
                                        <input name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
                                        <input name="surname" placeholder="Surname" value={formData.surname} onChange={handleChange} required />
                                        <input name="country" placeholder="Country" value={formData.country} onChange={handleChange} required />
                                        <input name="postal" placeholder="Postal Code" value={formData.postal} onChange={handleChange} />
                                        {/* Read-only email field */}
                                        {currentUser && (
                                            <input 
                                                name="email" 
                                                placeholder="Email" 
                                                value={currentUser.email} 
                                                readOnly 
                                                style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }} 
                                            />
                                        )}
                                        <input name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} />
                                    </div>
                                </div>
                                <label className='label-represent'>
                                    <input
                                        type="checkbox"
                                        name="representing_company"
                                        checked={formData.representing_company}
                                        onChange={handleChange}
                                    /> Representing a Company
                                </label>
                            </div>

                            <div className="user-change-pass">
                                <div className='us-prof-bg-div-btns'>
                                    <div className='change-aod'>
                                        <img className="up-profile-btns" src={lock} alt="lock" />
                                        <button className='change-pass-btn' type="button" onClick={() => setShowPasswordChange(true)}>
                                            Change Password
                                        </button>
                                    </div>
                                    {showPasswordChange && (
                                    <div className='show-pass-change'>
                                        <input
                                            type="password"
                                            placeholder="Current Password"
                                            value={currentPassword}
                                            onChange={(e) => setCurrentPassword(e.target.value)}
                                        />
                                        <input
                                            type="password"
                                            placeholder="New Password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}  
                                        />
                                        {passwordError && <p style={{ color: 'red' }}>{passwordError}</p>}
                                        {passwordSuccess && <p style={{ color: 'green' }}>{passwordSuccess}</p>}
                                        <div className="ch-pass-btns">
                                            <button
                                                className={`ch-pass-sub ${currentPassword && newPassword ? 'ch-pass-sub-ready' : ''}`}
                                                disabled={!currentPassword || !newPassword}
                                                onClick={() => {
                                                    if (!currentUser) return;
                                                    authService.changePassword(currentUser.access, currentPassword, newPassword)
                                                        .then(() => {
                                                            setPasswordSuccess('Password changed successfully.');
                                                            setPasswordError('');
                                                            setCurrentPassword('');
                                                            setNewPassword('');
                                                            setTimeout(() => setShowPasswordChange(false), 1500);
                                                        })
                                                        .catch((err) => {
                                                            const message = err?.response?.data?.detail || 'Failed to change password.';
                                                            setPasswordError(message);
                                                            setPasswordSuccess('');
                                                        });
                                                }}
                                            >
                                                Submit
                                            </button>
                                            <button
                                                className='ch-pass-can' 
                                                onClick={() => {
                                                setShowPasswordChange(false);
                                                setPasswordError('');
                                                setPasswordSuccess('');
                                                setCurrentPassword('');
                                                setNewPassword('');
                                            }}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                    )}
                                </div>
                                
                            </div>

                            <div className="us-prof-bg-div-btns">
                                <div className='del-btn-div'>
                                    <FontAwesomeIcon className="us-pro-trash" icon={faTrashCan} />
                                    <button type="button" onClick={() => setShowDeleteModal(true)} className="del-acc-btn">
                                        Delete My Account and All Data
                                    </button>
                                </div>
                            </div>
                            </div>

                            <div className="right-section">
                            {formData.representing_company ? (
                                <div className="company-inf">
                                    <div className='us-prof-bg-div'>
                                        <div className='usr-prof-imgs'><img className="up-profile" src={city} alt="city" /></div>
                                        <div className='inpts-div'>
                                            <input name="company" placeholder="Company Name" value={formData.company} onChange={handleChange} />
                                            <input name="nip_vat" placeholder="VAT/NIP" value={formData.nip_vat} onChange={handleChange} />
                                            <input name="position" placeholder="Position" value={formData.position} onChange={handleChange} />
                                            <input name="company_adress" placeholder="Company Address" value={formData.company_adress} onChange={handleChange} />
                                            <input name="company_country" placeholder="Company Country" value={formData.company_country} onChange={handleChange} />
                                            <input name="company_postal" placeholder="Company Postal Code" value={formData.company_postal} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="company-inf empty" />
                            )}
                            </div>
                        </div>

                        <div className="save-btn-wrapper">
                            <button className='save-profile' type="submit">Save</button>
                        </div>
                    </form>


                    {showModal && (
                    <div className="modal-overlay-uf">
                        <div className="modal-uf">
                            <div className='conf-sub-acc'><h3>Confirm Your Information</h3></div>
                            <ul className='save-acc-ul'>
                                <li><strong>Name:</strong> {formData.name}</li>
                                <li><strong>Surname:</strong> {formData.surname}</li>
                                <li><strong>Country:</strong> {formData.country}</li>
                                <li><strong>Postal:</strong> {formData.postal}</li>
                                <li><strong>Phone:</strong> {formData.phone}</li>
                                {formData.representing_company && (
                                    <>
                                        <li><strong>Company:</strong> {formData.company}</li>
                                        <li><strong>NIP/VAT:</strong> {formData.nip_vat}</li>
                                        <li><strong>Position:</strong> {formData.position}</li>
                                        <li><strong>Address:</strong> {formData.company_adress}</li>
                                        <li><strong>Country:</strong> {formData.company_country}</li>
                                        <li><strong>Postal:</strong> {formData.company_postal}</li>
                                    </>
                                )}
                            </ul>
                            <div className="modal-buttons-uf">
                                <button className='submit-acc-change' onClick={handleModalSubmit}>Submit</button>
                                <button onClick={handleModalCancel}>Cancel</button>
                            </div>
                        </div>
                    </div>
                    )}
                    {showDeleteModal && (
                        <div className="modal-overlay-uf">
                            <div className="modal-uf">
                                <div className='conf-del-acc'><h3>Confirm Account Deletion</h3></div>             
                                <p className='p-del-acc'>This action is irreversible. Please confirm your decision.</p>
                                <div className='div-del-acc'>
                                    <label className=''>
                                        <input
                                        type="checkbox"
                                        checked={confirmDelete}
                                        onChange={(e) => setConfirmDelete(e.target.checked)}
                                        />
                                        {' '}Yes, I really want to delete my account and all data.
                                    </label>
                                    <input
                                        className='del-acc-pass'
                                        type="password"
                                        placeholder="Enter your password"
                                        value={deletePassword}
                                        onChange={(e) => setDeletePassword(e.target.value)}
                                    />
                                </div>
                                {deleteError && <p style={{ color: 'red' }}>{deleteError}</p>}

                                <div className="modal-buttons-uf">
                                    <button
                                    disabled={!confirmDelete || !deletePassword}
                                    onClick={handleDeleteAccount}
                                    >
                                    Delete
                                    </button>
                                    <button onClick={() => setShowDeleteModal(false)}>Cancel</button>
                                </div>
                            </div>
                        </div>
                        )}
                        {/* {showPasswordModal && (
                            <div className="modal-overlay-uf">
                                <div className="modal-uf">
                                    <h3>Change Password</h3>
                                    <input
                                        type="password"
                                        placeholder="Current Password"
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                        style={{ marginTop: '10px', width: '100%' }}
                                    />
                                    <input
                                        type="password"
                                        placeholder="New Password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        style={{ marginTop: '10px', width: '100%' }}
                                    />
                                    {passwordError && <p style={{ color: 'red' }}>{passwordError}</p>}
                                    {passwordSuccess && <p style={{ color: 'green' }}>{passwordSuccess}</p>}
                                    <div className="modal-buttons-uf">
                                        <button
                                            disabled={!currentPassword || !newPassword}
                                            onClick={() => {
                                                if (!currentUser) return;
                                                authService.changePassword(currentUser.access, currentPassword, newPassword)
                                                    .then(() => {
                                                        setPasswordSuccess('Password changed successfully.');
                                                        setPasswordError('');
                                                        setCurrentPassword('');
                                                        setNewPassword('');
                                                        setTimeout(() => setShowPasswordModal(false), 1500);
                                                    })
                                                    .catch((err) => {
                                                        const message = err?.response?.data?.detail || 'Failed to change password.';
                                                        setPasswordError(message);
                                                        setPasswordSuccess('');
                                                    });
                                            }}
                                        >
                                            Submit
                                        </button>
                                        <button onClick={() => {
                                            setShowPasswordModal(false);
                                            setPasswordError('');
                                            setPasswordSuccess('');
                                            setCurrentPassword('');
                                            setNewPassword('');
                                        }}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )} */}

                </div>
            </div>
        </div>
    );
};

export default UserForm;